import React from 'react';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { sortButtonStyles } from '../../../../TCSMApp/global/constants/theme/styles/tables/sort-button';

interface Props {    
    label: string;
    isDescending: boolean;
    onToggleSort: ()=> void;
    noSort?: boolean;
}

function SortButton(props: Props){
    const { isDescending, onToggleSort } = props;
    const classes = sortButtonStyles();            

    if (props.noSort){
        return (
            <button className={`un-button input-label ${classes.sortButton}`} type='button'><span>{props.label}</span></button>
        );    
    }

    return (
        <button className={`un-button input-label ${classes.sortButton} ${ isDescending ? 'active' : ''} `} type='button' onClick={onToggleSort} ><span>{props.label} <ArrowDropDownIcon /></span></button>
    );
}

SortButton.defaultProps = {
    noSort: false,
};

export default SortButton;